<template>
  <div>
    <h1 class="page-header">{{ $t('healthCategory.pageTitle') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-5 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <form-create
              @success_create="fetchData"
              :edit="edit_data"
              @success_update="edit_data = ''"
              @cancel="fetchData"
            ></form-create>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-7 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="row">
              <div
                class="col-lg-9 com-md-9 col-sm-12 d-flex justify-content-start"
              ></div>
              <div
                class="col-lg-3 com-md-3 col-sm-12 d-flex justify-content-end"
              >
                <ts-input
                  v-model="search"
                  :placeholder="$t('search')"
                  style="width: 300px"
                  class="kh-font"
                />
              </div>
            </div>
          </ts-card-wrapper>
          <ts-card-wrapper>
            <ts-table
              :columns="columns"
              :records="resources"
              :loading="loading"
            >
              <template v-slot="{ record }">
                <td>{{ record.health_category_description }}</td>
                <td class="kh-font">
                  {{ record.health_category_description_kh }}
                </td>
                <td class="text-center">
                  <a
                    href="#"
                    title="edit"
                    class="text-primary mr-2"
                    @click.prevent="edit(record)"
                  >
                    <i class="fas fa-edit"></i>
                  </a>
                  <a
                    href="#"
                    title="delete"
                    class="text-danger"
                    @click.prevent="destroy(record.health_category_id)"
                  >
                    <i class="fas fa-trash"></i>
                  </a>
                </td>
              </template>
            </ts-table>
            <ts-card-wrapper class="d-flex justify-content-end p-15">
              <ts-pagination v-model="pagination" @navigate="fetchData">
              </ts-pagination>
            </ts-card-wrapper>
          </ts-card-wrapper>
        </ts-card>
      </div>
    </div>
  </div>
</template>
<script>
import FormCreate from './form.vue'
import { mapState } from 'vuex'
import { debounce } from 'lodash'

export default {
  components: {
    FormCreate
  },
  name: 'health-category',
  props: ['editData'],

  data () {
    return {
      loading: false,
      edit_data: this.editData,

      columns: [
        { name: this.$t('healthCategory.healthCategoryEn') },
        { name: this.$t('healthCategory.healthCategoryKh') },
        {
          name: this.$t('actions'),
          style: 'width: 1px; text-align:center'
        }
      ]
    }
  },
  computed: {
    ...mapState('healthCategory', ['resources', 'pagination']),
    search: {
      get () {
        return this.$store.state.healthCategory.search
      },
      set (newVal) {
        this.$store.commit('healthCategory/SET_SEARCH', newVal)
        this.$store.commit('healthCategory/RESET_CURRENT_PAGE')
      }
    }
  },
  created () {
    this.fetchData()
  },
  methods: {
    fetchData (attributes) {
      this.loading = true
      this.$store
        .dispatch('healthCategory/fetch', attributes)
        .then(() => (this.loading = false))
        .catch(error => {
          this.$toasted.error(error.message)
          this.loading = false
        })
    },
    edit (data) {
      this.edit_data = data
      this.$router.push(`/health-categories/${data.health_category_id}`)
    },
    async destroy (health_category_id) {
      if (await this.$confirmModal.danger('Are you sure to delete ?')) {
        this.$store
          .dispatch('healthCategory/delete', health_category_id)
          .then(response => {
            this.$toasted.success(response.message)
            this.fetchData()
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
      }
    }
  },
  watch: {
    search: debounce(function (search) {
      this.fetchData({ search })
    }, 500)
  }
}
</script>
